import { InjectionToken } from '@angular/core';

export interface ServiceStatusResult {
  status: boolean;
}

export interface ServiceStatusProvider {
  getServiceStatus(serviceName: string): Promise<ServiceStatusResult | undefined>;
  getConfigByAppConfig(): Promise<unknown>;
}

export const SERVICE_STATUS_PROVIDER = new InjectionToken<ServiceStatusProvider>('SERVICE_STATUS_PROVIDER');
